import React from "react";

import DocumentationIconButton from "components/DocumentationIconButton";
import { ThumbUp } from "components/icons/generated";
import SearchInput from "components/SearchInput";
import { SEARCH_PLACEHOLDERS } from "constants/searchPlaceholders";
import ViewHeader from "components/ViewHeader";
import ViewHeaderTitle from "components/ViewHeader/Title";
import ViewHeaderWrapper from "components/ViewHeader/Wrapper";
import ButtonIcon from "ds/components/ButtonIcon";
import useTitle from "hooks/useTitle";
import useTypedContext from "hooks/useTypedContext";
import { getDocsUrl } from "utils/getDocsUrl";
import { AccountContext } from "views/AccountWrapper";
import FiltersMobileTriggerButton from "components/Filters/MobileTriggerButton";
import MobileView from "components/Mobile/MobileView";
import DesktopView from "components/Mobile/DesktopView";

import { FILTERS_ORDER_SETTINGS_KEY, STACK_LIST_NEW_FEEDBACK_ID } from "./constants";
import StacksCreateStackButton from "./CreateStackButton";
import styles from "./styles.module.css";

type StacksPageLayoutProps = {
  children: React.ReactNode;
};

const StacksPageLayout = ({ children }: StacksPageLayoutProps) => {
  const { accountName } = useTypedContext(AccountContext);

  useTitle(`Stacks · ${accountName}`);

  return (
    <>
      <ViewHeader firstLevel className={styles.header}>
        <ViewHeaderWrapper>
          <ViewHeaderTitle>Stacks</ViewHeaderTitle>
          <MobileView>
            <StacksCreateStackButton />
          </MobileView>
        </ViewHeaderWrapper>

        <ViewHeaderWrapper direction="row">
          <SearchInput
            placeholder={SEARCH_PLACEHOLDERS.STACKS}
            filtersOrderSettingsKey={FILTERS_ORDER_SETTINGS_KEY}
          />
          <FiltersMobileTriggerButton />
          <DesktopView>
            <DocumentationIconButton
              href={getDocsUrl("/concepts/stack")}
              tooltipText="Go to stacks documentation"
            />

            <ButtonIcon
              size="medium"
              variant="secondary"
              id={STACK_LIST_NEW_FEEDBACK_ID}
              icon={ThumbUp}
            >
              Leave feedback
            </ButtonIcon>

            <StacksCreateStackButton />
          </DesktopView>
        </ViewHeaderWrapper>
      </ViewHeader>
      {children}
    </>
  );
};

export default StacksPageLayout;
